module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (35).da55e171.jpg";